<div class="padding">
  <h1 class="left-box">{{ 'common.labels.alerts' | transloco }}</h1>
  <!-- One card for the filter, table and paginator, matching the client portal's Alerts page -->
  <mat-card>
    <mat-card-content>
      <app-alerts-filter></app-alerts-filter>
      <div class="spacer-small"></div>
      <div class="table-container">
        <!-- Conditional paginator at the top (show only when 50 or more alerts are displayed) -->
        @if (((this.repo.resource$ | async)?.length ?? 0) >= 50) {
          <mat-paginator [pageSize]="this.repo.pageSize$ | async"
            [length]="this.repo.resourceCount$ | async" [pageIndex]="this.repo.pageNum$ | async"
            [pageSizeOptions]="[10, 25, 50, 100]" showFirstLastButtons="true" (page)="page($event)"></mat-paginator>
          <div class="spacer-small"></div>
        }
        <table mat-table matSort [dataSource]="this.repo.resource$" class="mat-elevation-z0" (matSortChange)="sort($event)"
          [class.table-loading]="this.repo.loading$ | async">
          <!-- Not sortable: the API can only sort by corporation ID, which isn't a meaningful order -->
          <ng-container matColumnDef="corporation">
            <th mat-header-cell *matHeaderCellDef> {{ 'common.labels.corporation' | transloco }} </th>
            <td mat-cell *matCellDef="let alert"> {{ corporationName(alert) }} </td>
          </ng-container>
          <ng-container matColumnDef="alertSeverityID">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> {{ 'common.labels.severity' | transloco }} </th>
            <td mat-cell *matCellDef="let alert">
              <span class="alert-pill" [ngClass]="severityClass(alert.alertSeverityID)">{{ alert.alertSeverityID | enumLabel:'alertSeverity' }}</span>
            </td>
          </ng-container>
          <ng-container matColumnDef="alertTypeID">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> {{ 'common.labels.alertType' | transloco }} </th>
            <td mat-cell *matCellDef="let alert"> {{ alert.alertTypeID | enumLabel:'alertType':alertTypeName(alert) }} </td>
          </ng-container>
          <ng-container matColumnDef="subject">
            <th mat-header-cell *matHeaderCellDef> {{ 'common.labels.subject' | transloco }} </th>
            <td mat-cell *matCellDef="let alert"> {{ subject(alert.trackedAlertEntity) }} </td>
          </ng-container>
          <ng-container matColumnDef="description">
            <th mat-header-cell *matHeaderCellDef> {{ 'common.labels.description' | transloco }} </th>
            <td mat-cell *matCellDef="let alert" class="description-cell" [matTooltip]="alert.description"> {{ alert.description }} </td>
          </ng-container>
          <ng-container matColumnDef="alertStatusID">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> {{ 'common.labels.status' | transloco }} </th>
            <td mat-cell *matCellDef="let alert">
              <span class="alert-pill" [ngClass]="statusClass(alert.alertStatusID)">{{ alert.alertStatusID | enumLabel:'alertStatus' }}</span>
            </td>
          </ng-container>
          <!-- localizedDate, not utcToLocalDate: alerts are stored in server local time, so converting from UTC shifts them -->
          <ng-container matColumnDef="added">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> {{ 'common.labels.raised' | transloco }} </th>
            <td mat-cell *matCellDef="let alert" class="nowrap-cell"> {{ alert.added | localizedDate:'yyyy-MM-dd' }} </td>
          </ng-container>
          <ng-container matColumnDef="view">
            <th mat-header-cell *matHeaderCellDef [attr.aria-label]="'common.labels.rowActions' | transloco">&nbsp;</th>
            <td mat-cell *matCellDef="let alert" class="nowrap-cell">
              <button mat-icon-button color="accent" (click)="viewAlert(alert, false)" [attr.aria-label]="'common.labels.viewAlert' | transloco">
                <mat-icon>article</mat-icon>
              </button>
              <button mat-icon-button color="accent" (click)="viewAlert(alert, true)" [attr.aria-label]="'alerts.viewAlertInANewTab' | transloco">
                <mat-icon>open_in_new</mat-icon>
              </button>
            </td>
          </ng-container>
          <tr mat-header-row *matHeaderRowDef="columnsToDisplay"></tr>
          <tr mat-row *matRowDef="let row; columns: columnsToDisplay;" [class.alert-row-resolved]="row.alertStatusID === 'Resolved'"
            [attr.data-testid]="'alert-row-' + row.id"></tr>
        </table>
        @if ((this.repo.resourceCount$ | async) === 0 && !(this.repo.loading$ | async)) {
          <lib-placeholder [iconName]="'notifications_none'" [message]="'common.messages.noAlertsFound' | transloco" [condition]="true"></lib-placeholder>
        }
        <lib-placeholder [iconName]="'cancel'" [iconClass]="'icon-error'" [message]="'common.messages.errorLoadingAlerts' | transloco"
          [condition]="(this.repo.error$ | async) ?? false"></lib-placeholder>
      </div>
      <div class="spacer-small"></div>
      @if (((this.repo.resourceCount$ | async) ?? 0) > 0) {
        <mat-paginator [pageSize]="this.repo.pageSize$ | async"
          [length]="this.repo.resourceCount$ | async" [pageIndex]="this.repo.pageNum$ | async"
          [pageSizeOptions]="[10, 25, 50, 100]" showFirstLastButtons="true" (page)="page($event)"></mat-paginator>
      }
    </mat-card-content>
  </mat-card>
</div>
